import { Typography } from "../Typography";

export const Tab = ({ tab, currentTab, handleTabClick }) => {
  return (
    <li
      tabIndex={1}
      className={`tab button button--secondary button--large ${
        currentTab === `${tab.id}` ? "active" : ""
      } `}
      id={`${tab.id}`}
      onClick={() => handleTabClick(`${tab.id}`)}
    >
      <Typography Tag="p" classname="tab-text-mobile">
        {tab.labelMobile}
      </Typography>

      <Typography Tag="p" classname="tab-text">
        {tab.label}
      </Typography>
    </li>
  );
};
